import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';

export type WorkflowErrorItem = {
    timestamp: string;
    message: string;
    code: string | null;
    threadId: string;
    runId: string;
    stack: string | null;
    stepId: string | null;
    stepName: string | null;
    stepType: string | null;
};

type WorkflowErrorsMeta = {
    limit: number;
    returned: number;
};

type WorkflowErrorsResponse = {
    errors: WorkflowErrorItem[];
    meta: WorkflowErrorsMeta;
};

type UseWorkflowErrorsParams = {
    workflowId: string;
    organizationId: string;
    limit: number;
    enabled: boolean;
};

type UseWorkflowErrorsResult = {
    errors: WorkflowErrorItem[];
    meta: WorkflowErrorsMeta | null;
    isLoading: boolean;
    error: Error | undefined;
};

const useWorkflowErrors = ({
    workflowId,
    organizationId,
    limit,
    enabled,
}: UseWorkflowErrorsParams): UseWorkflowErrorsResult => {
    const queryParams = new URLSearchParams({
        organizationId,
        limit: String(limit),
    });
    const pathname = `/workflows/${workflowId}/errors?${queryParams.toString()}`;

    const { data, isLoading, error } = useHttpQuery<WorkflowErrorsResponse>({
        pathname,
        method: 'GET',
        key: ['workflow-errors', workflowId, organizationId, String(limit)],
        queryOptions: {
            enabled: enabled && !!workflowId && !!organizationId,
            staleTime: 60 * 1000,
        },
    });

    return {
        errors: data?.errors ?? [],
        meta: data?.meta ?? null,
        isLoading,
        error: error || undefined,
    };
};

export default useWorkflowErrors;
export type { UseWorkflowErrorsParams };
